"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = Tab;
exports.Tabs = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _reactRouterDom = require("react-router-dom");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _routerLink = _interopRequireDefault(require("./links/router-link"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["children", "disabled", "exact", "path"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Export `Tabs` styled component.
 */
var Tabs = _styledComponents["default"].div.attrs({
  role: 'tablist'
}).withConfig({
  displayName: "tabs__Tabs",
  componentId: "sc-1ctpgf6-0"
})(["border-bottom:1px solid ", ";display:flex;font-size:14px;overflow-x:auto;overflow-y:hidden;", ""], (0, _styles.color)('gray400'), _styles.media.min('sm')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "]))));
/**
 * `Link` styled component.
 */


exports.Tabs = Tabs;
var Link = (0, _styledComponents["default"])(_routerLink["default"]).withConfig({
  displayName: "tabs__Link",
  componentId: "sc-1ctpgf6-1"
})(["color:", ";padding:12px 4px;position:relative;text-decoration:none;transition:color ", ";white-space:nowrap;", " &:hover,&:focus{color:", ";", "}&::before{background-color:", ";bottom:-1px;content:'';height:2px;left:0;position:absolute;right:0;transform:scaleX(", ");transition:transform ", ";}", " &:not(:first-child){margin-left:16px;}"], (0, _styles.color)('secondary'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('isSelected', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('primary'))), (0, _styles.color)('primary'), (0, _styledTools.ifProp)('isSelected', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('blue700'))), (0, _styles.color)('primary'), (0, _styledTools.ifProp)('isSelected', 1, 0), (0, _styledTools.theme)('animations.fastTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["cursor:default;opacity:0.5;pointer-events:none;"])));
/**
 * Export `Tab` component.
 */

function Tab(props) {
  var children = props.children,
      disabled = props.disabled,
      _props$exact = props.exact,
      exact = _props$exact === void 0 ? true : _props$exact,
      path = props.path,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: exact,
    path: (0, _get2["default"])(path, 'pathname', path)
  }, function (_ref) {
    var match = _ref.match;
    return /*#__PURE__*/_react["default"].createElement(Link, _extends({}, rest, {
      "aria-disabled": disabled,
      "aria-selected": !!match,
      disabled: disabled,
      isSelected: !!match,
      role: 'tab',
      to: disabled ? null : {
        pathname: (0, _get2["default"])(path, 'pathname', path),
        state: (0, _get2["default"])(path, 'state')
      }
    }), children);
  });
}